import {
  FormField,
  FormPayload,
  PaymentFormSchema,
  PaymentTypes,
  ValidationStatuses,
} from '@cashier/cashier-model';
import { FieldValidator } from '@cashier/cashier-shared';

const getSchemaFields = (formSchema: PaymentFormSchema): FormField[] => {
  const { staticData, cardData, commonFieldMap } = formSchema;

  const fields: FormField[] = [];

  Object.values(staticData).forEach((field: FormField) => {
    fields.push(field);
  });

  if (cardData) {
    Object.values(cardData).forEach((field: FormField) => {
      fields.push(field);
    });
  }

  if (commonFieldMap) {
    Object.values(commonFieldMap).forEach((field: FormField) => {
      fields.push(field);
    });
  }

  return fields;
};

export const FormPayloadFactory = {
  fromFormSchema: (
    formSchema: PaymentFormSchema,
    context: { paymentType: PaymentTypes; balance: string | null },
  ): FormPayload => {
    return getSchemaFields(formSchema).reduce<FormPayload>((acc, field) => {
      const { params, value } = field;

      const validationReport: {
        status: ValidationStatuses;
        errors: string[];
      } = FieldValidator[field.validatorType](field, context);

      acc[field.name] = {
        value,
        errors: validationReport.errors,
        validationStatus: validationReport.status,
        interactionCompleted: true,
        ...(params?.isUiOnly ? { isUiOnly: true } : {}),
      };

      return acc;
    }, {});
  },
};
